import { ValidationRuleDTO } from "./validationRuleDTO";

export class ValidationProtocolDTO {

    public id!: number;
    public sequenceNo!: number;
    public validationRules!: ValidationRuleDTO[];
    public validationOr!: boolean;

    constructor(){
        this.validationRules = new Array();
    }
}